/**
 * Source: https://github.com/left-pad/left-pad/blob/master/LICENSE
 */
const cache = ['', ' ', '  ', '   ', '    ', '     ', '      ', '       ', '        ', '         '];

export function leftPad(text: string | number, length: number, padCharacter = ' ') {
  // convert `str` to a `string`
  const str = `${text}`;
  // `len` is the `pad`'s length now
  length -= str.length;
  // doesn't need to pad
  if (length <= 0) return str;

  // cache common use cases
  if (padCharacter === ' ' && length < 10) return cache[length] + str;
  // `pad` starts with an empty string
  let pad = '';
  // loop
  while (true) {
    // add `ch` to `pad` if `len` is odd
    if (length & 1) pad += padCharacter;
    // divide `len` by 2, ditch the remainder
    length >>= 1;
    // "double" the `ch` so this operation count grows logarithmically on `len`
    // each time `ch` is "doubled", the `len` would need to be "doubled" too
    // similar to finding a value in binary search tree, hence O(log(n))
    if (length) padCharacter += padCharacter;
    // `len` is 0, exit the loop
    else break;
  }
  // pad `str`!
  return pad + str;
}

export function rightPad(text: string | number, length: number, padCharacter = ' ') {
  // convert `str` to a `string`
  const str = `${text}`;
  // `len` is the `pad`'s length now
  length -= str.length;
  // doesn't need to pad
  if (length <= 0) return str;

  // cache common use cases
  if (padCharacter === ' ' && length < 10) return str + cache[length];
  // `pad` starts with an empty string
  let pad = '';
  // loop
  while (true) {
    // add `ch` to `pad` if `len` is odd
    if (length & 1) pad += padCharacter;
    // divide `len` by 2, ditch the remainder
    length >>= 1;
    // "double" the `ch` so this operation count grows logarithmically on `len`
    // each time `ch` is "doubled", the `len` would need to be "doubled" too
    // similar to finding a value in binary search tree, hence O(log(n))
    if (length) padCharacter += padCharacter;
    // `len` is 0, exit the loop
    else break;
  }
  // pad `str`!
  return str + pad;
}
